import Page from "./Page";
export default Page;



// WEBPACK FOOTER //
// ./src/components/App/Page/index.js